var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-icon.ts
import "@adornis/ass/style";
import { A } from "@adornis/base/env-info";
import { customElement } from "lit/decorators.js";
import { ChemistryLiteElement } from "../../chemistry-lite-element";
var fonts = {
  "material-filled": {
    link: A.absoluteUrl("/__fonts/google/font") + "/s/materialicons/v139/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2",
    name: "Material Icons"
  },
  "material-outlined": {
    link: A.absoluteUrl("/__fonts/google/font") + "/s/materialiconsoutlined/v108/gok-H7zzDkdnRel8-DQ6KAXJ69wP1tGnf4ZGhUce.woff2",
    name: "Material Icons Outlined"
  },
  "material-rounded": {
    link: A.absoluteUrl("/__fonts/google/font") + "/s/materialiconsround/v107/LDItaoyNOAY6Uewc665JcIzCKsKc_M9flwmP.woff2",
    name: "Material Icons Round"
  },
  "material-two-tone": {
    link: A.absoluteUrl("/__fonts/google/font") + "/s/materialiconstwotone/v111/hESh6WRmNCxEqUmNyh3JDeGxjVVyMg4tHGctNCu0.woff2",
    name: "Material Icons Two Tone"
  },
  "material-sharp": {
    link: A.absoluteUrl("/__fonts/google/font") + "/s/materialiconssharp/v108/oPWQ_lt5nv4pWNJpghLP75WiFR4kLh3kvmvR.woff2",
    name: "Material Icons Sharp"
  },
  img: {
    link: "",
    name: "Image"
  }
};
var globalFontReference = {};
async function ensureGlobalFontReference(type = "material-filled") {
  if (globalFontReference[type])
    return;
  globalFontReference[type] = new FontFace(fonts[type].name, `url(${fonts[type].link})`, {
    family: "'Material Icons'"
  });
  await globalFontReference[type].load();
  document.fonts.add(globalFontReference[type]);
}
var ElementsIcon = class extends ChemistryLiteElement {
  styles() {
    return {
      fontSize: "1em",
      fontStyle: "normal",
      display: "inline-block",
      lineHeight: "1",
      textTransform: "none",
      letterSpacing: "normal",
      wordWrap: "normal",
      whiteSpace: "nowrap",
      direction: "ltr",
      fontFamily: "'Material Icons'",
      boxSizing: "content-box",
      maxWidth: "1em",
      WebkitFontSmoothing: "antialiased",
      textRendering: "optimizeLegibility",
      MozOsxFontSmoothing: "grayscale",
      fontFeatureSettings: "liga",
      verticalAlign: "bottom",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "center"
    };
  }
  constructor() {
    super();
    this.initFont();
  }
  initFont() {
    const fontType = this.getAttribute("type") || "material-filled";
    if (!Object.keys(fonts).includes(fontType))
      throw new Error(`X-ICON:: ${fontType} given. Only allowed types are: ${Object.keys(fonts).join(", ")}`);
    (async () => {
      this.style.setProperty("opacity", "0");
      if (fontType !== "img") {
        await ensureGlobalFontReference(fontType);
        this.style.fontFamily = `'${fonts[fontType].name}'`;
      } else {
        const imgSrc = this.getAttribute("src");
        if (!imgSrc)
          return console.warn("X-ICON:: No 'src' given for img type icon");
        this.style.backgroundImage = `url('${imgSrc}')`;
        this.style.width = "1em";
        this.style.height = "1em";
      }
      this.style.removeProperty("opacity");
    })().catch((e) => console.error("error while setting up fonts", e));
  }
  static get observedAttributes() {
    return ["type", "src"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if ((name === "type" || name === "src") && oldValue !== newValue)
      this.initFont();
  }
};
ElementsIcon = __decorateClass([
  customElement("x-icon")
], ElementsIcon);
export {
  ElementsIcon,
  ensureGlobalFontReference
};
